export default "__VITE_ASSET__Dcm8oKZp__"